import { useRef, useState, useEffect, useContext } from "react";
// mui
import Slider from "@mui/material/Slider";
import {
  Deletesvg,
  Minimizesvg,
  PopupSvg,
} from "src/components/UI/Drawer-Widget/icons";
// assets
import styles from "src/components/UI/Drawer-Widget/assets/css/Draw.module.scss";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

const colors = [
  { color: "#f10da1" },
  { color: "#ab42fa" },
  { color: "#1973b9" },
  { color: "#27dec4" },
  { color: "#23ff29" },
  { color: "#fdfe31" },
  { color: "#fba524" },
  { color: "#fd0216" },
];

interface IProps {
  id: string;
  text: any;
  isEditing: boolean;
  coordinates: number[];
  selectedColor: string;
  size: number;
  type: string;
  txtChangeHandler: (id: string, val: string) => void;
  setEditHandler: (id: string, isEditing: boolean) => void;
  colorChangeHandler: (id: string, color: string) => void;
  sizeChangeHandler: (id: string, size: number) => void;
  deleteHandler: (id: string) => void;
}
const minLabelHeight = 23;
const maxLabelHeight = 39;
const TextPopup = ({
  id = "",
  text = "",
  type = "",
  size = 2,
  isEditing = true,
  coordinates = [50, 50],
  selectedColor = "",
  deleteHandler,
  txtChangeHandler,
  sizeChangeHandler,
  setEditHandler,
  colorChangeHandler,
}: IProps) => {
  const activePanel = useSelector((state: any) => state.app.activePanel);

  const [fontColor, setFontColor] = useState("white");
  const [popupHeight, setPopupHeight] = useState(0);
  const [leftOffset, setLeftOffset] = useState(0);

  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    let element = document.getElementsByClassName("esri-view-root");
    const rect = element[0].getBoundingClientRect();
    setLeftOffset(rect.left);
    console.log(rect);
  }, [activePanel]);
  useEffect(() => {
    if (containerRef.current) {
      //  const textHeight = containerRef.current.scrollHeight;
      const textWidth = containerRef.current.offsetWidth + 10;
      const imgElement = document.getElementById(`speech_bubble_img_${id}`);
      if (imgElement) {
        imgElement.style.width = `${textWidth}px`;
        const bRect = imgElement.getBoundingClientRect();
        setPopupHeight(bRect.height);
        containerRef.current.style.whiteSpace =
          textWidth < 125 ? "nowrap" : "initial";
      }
    }
  }, [text, isEditing]);

  return (
    <div
      style={{
        zIndex: 1,
        position: "fixed",
        left: `${coordinates[0] + leftOffset}px`,
        top: `${coordinates[1] - 7}px`,
        width: "220px",
        minWidth: "50px",
        height: `auto`,
        borderRadius: "5px",
        border: !isEditing ? "none" : "3px solid #4E6E81",
        backgroundColor: "#2E3840DE",
      }}
    >
      {isEditing ? (
        <div className={styles["popup-tools-container"]}>
          <input
            onKeyDown={(evt) => {
              if (evt.keyCode === 13) {
                setEditHandler(id, false);
              }
            }}
            type="text"
            placeholder="Enter annotation text..."
            className={styles["txt-input"]}
            value={text}
            onChange={(evt) => {
              txtChangeHandler(id, evt.target.value);
            }}
          />
          <div className={styles["size-container"]}>
            <label className={styles["lbl-size"]}>WIDTH: </label>
            <Slider
              aria-label="Small"
              max={15}
              min={1}
              onChange={(evt) => {
                const inputElement = evt.target as HTMLInputElement;
                if (inputElement) {
                  sizeChangeHandler(id, parseInt(inputElement.value));
                }
              }}
              size="small"
              step={1}
              className={styles["stepper"]}
              value={size}
            />
            <input
              className={styles["txt-size"]}
              value={size}
              onChange={(evt) => {
                sizeChangeHandler(id, parseInt(evt.target.value));
              }}
            />
          </div>
          <div className={styles["color-container"]}>
            {colors.map((x) => (
              <div
                onClick={() => {
                  if (x.color === "#fdfe31") {
                    setFontColor("black");
                  } else {
                    setFontColor("white");
                  }
                  colorChangeHandler(id, x.color);
                }}
                className={styles["color-item"]}
                style={{
                  backgroundColor: x.color,
                  border:
                    x.color === selectedColor ? "1px white solid" : "none",
                }}
              />
            ))}
          </div>
          <div className={styles["delete-minimize-container"]}>
            <div
              className={styles["delete-container"]}
              onClick={() => {
                deleteHandler(id);
              }}
            >
              <Deletesvg />
              <div className={styles["lbl-delete"]}>DELETE</div>
            </div>
            <span
              onClick={() => {
                setEditHandler(id, false);
              }}
            >
              <Minimizesvg />
            </span>
          </div>
        </div>
      ) : type !== "text" ? (
        <div
          title={text}
          className={styles.box}
          style={{
            left: "-15px",
            top: `${0 - popupHeight}px`,
            color: `${fontColor}`,
            maxHeight: `${maxLabelHeight}px`,
            minHeight: `${minLabelHeight}px`,
          }}
          onClick={() => {
            setEditHandler(id, true);
          }}
        >
          {/* <img
            src={speech_bubble_img}
            className="img"
            id={`speech_bubble_img_${id}`}
          /> */}
          <span
            className={styles.img}
            id={`speech_bubble_img_${id}`}
            style={{
              minWidth: `${text ? 100 : 33}px`,
            }}
          >
            <PopupSvg color={selectedColor} />
          </span>
          <span ref={containerRef} className={styles.text}>
            {text.substring(0, 160)}
          </span>
        </div>
      ) : null}
    </div>
  );
};
export default TextPopup;
